import { useEffect, useState } from "react";
import api from "@/lib/api";
import {LAST_KEY,isReminderDue,markReminder} from "./reminderSchedule";

const empty = { message:"Admin, segera cek pesanan Instant/Prioritas di Ginee!", kind:"REMINDER",
  schedule_type:"INTERVAL", interval_minutes:10, daily_time_wib:"09:00", duration_seconds:10,
  target_roles:["OWNER","ADMIN_INVENTORY","CHECKER_OPERATOR"], enabled:true };

export default function GineeReminder({ enabled = true, canConfigure = false }) {
  const [items,setItems] = useState([]);
  const [banner,setBanner] = useState(null);
  const [editing,setEditing] = useState(false);
  const [draft,setDraft] = useState(empty);
  const [error,setError] = useState("");
  const [saving,setSaving] = useState(false);
  const [syncFailed,setSyncFailed] = useState(false);
  const [notice,setNotice] = useState("");
  const [search,setSearch] = useState("");
  const [filter,setFilter] = useState("ALL");
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    let requested = 0;
    const refresh = async () => {
      const sequence = ++requested;
      try {
        const { data } = await api.get("/operational-reminders");
        // Ignore older responses that arrive after a newer owner update.
        if (alive && sequence === requested) {
          setItems(Array.isArray(data) ? data : []);
          setSyncFailed(false);
        }
      } catch {
        if (alive && sequence === requested) {
          setItems([]);
          setSyncFailed(true);
        }
      }
    };
    refresh();
    // Refresh on return to ERP so Owner updates are not delayed by a background tab.
    const onVisible = () => { if (!document.hidden) refresh(); };
    document.addEventListener("visibilitychange", onVisible);
    const id = window.setInterval(refresh,30000);
    return () => {
      alive=false;
      window.clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  },[enabled]);
  useEffect(() => {
    if (!enabled) return undefined;
    const check = () => {
      if (banner || editing || document.hidden) return;
      const now=Date.now();
      const next=items.find(item => {
        try {
          const key=LAST_KEY+"."+item.id;
          if(item.schedule_type==="INTERVAL" && !localStorage.getItem(key)) localStorage.setItem(key,String(now));
          return isReminderDue(item,now,localStorage);
        } catch { return false; }
      });
      if (!next) return;
      try { markReminder(next,now,localStorage); } catch { return; }
      setBanner(next);

    };
    check();
    const timer=window.setInterval(check,1000);
    return () => {window.clearInterval(timer);};
  },[enabled,items,banner,editing]);
  useEffect(() => {
    if (!banner) return undefined;
    const timeout = window.setTimeout(() => setBanner(null),
      Math.max(5, Number(banner.duration_seconds) || 10) * 1000);
    return () => window.clearTimeout(timeout);
  }, [banner]);
  if (!enabled) return null;
  const save = async () => {
    setSaving(true);setError("");
    try {
      const payload = {...draft, message:draft.message.trim(), interval_minutes:Number(draft.interval_minutes),
        duration_seconds:Number(draft.duration_seconds),daily_time_wib:draft.schedule_type==="DAILY"?draft.daily_time_wib:null};
      if (!payload.message) throw new Error("Isi pesan wajib ada");
      if (!payload.target_roles.length) throw new Error("Pilih minimal satu penerima");
      if (draft.id) await api.put("/operational-reminders/"+encodeURIComponent(draft.id),payload);
      else await api.post("/operational-reminders",payload);
      const {data}=await api.get("/operational-reminders");
      setItems(data);setDraft({...empty});setNotice("Pengaturan berhasil disimpan");
    } catch(e){setError(e.response?.data?.detail || e.message || "Gagal menyimpan");}
    finally {setSaving(false);}
  };
  const remove = async item => {
    if (!window.confirm('Hapus permanen pengingat "' + item.message.slice(0,90) + '"? Tindakan ini tidak dapat dibatalkan.')) return;
    setSaving(true); setError(""); setNotice("");
    try {
      await api.delete("/operational-reminders/" + encodeURIComponent(item.id));
      const {data}=await api.get("/operational-reminders");
      setItems(data); if (draft.id === item.id) setDraft(empty);
      if (banner?.id === item.id) setBanner(null);
      setNotice("Pengingat berhasil dihapus");
    } catch(e) { setError(e.response?.data?.detail || e.message || "Gagal menghapus pengingat"); }
    finally {setSaving(false);}
  };
  const toggle = async item => {
    setSaving(true); setError(""); setNotice("");
    try {
      const payload = {message:item.message,kind:item.kind,schedule_type:item.schedule_type,
        interval_minutes:item.interval_minutes,daily_time_wib:item.daily_time_wib,
        duration_seconds:item.duration_seconds,target_roles:item.target_roles,enabled:!item.enabled};
      await api.put("/operational-reminders/"+encodeURIComponent(item.id),payload);
      const {data}=await api.get("/operational-reminders");
      setItems(data); if(draft.id === item.id) setDraft({...item,enabled:!item.enabled});
      setNotice(!item.enabled ? "Pengingat diaktifkan" : "Pengingat dinonaktifkan");
    } catch(e){setError(e.response?.data?.detail || e.message || "Gagal mengubah status");}
    finally {setSaving(false);}
  };
  return <>
    {canConfigure && syncFailed && <div role="alert" style={{position:"fixed",right:12,bottom:62,zIndex:9000,background:"#fff1f0",color:"#8a1717",padding:"8px 12px",border:"1px solid #d66",borderRadius:8}}>Pengingat tidak tersinkron. Periksa koneksi server.</div>}
    {canConfigure && <button type="button" data-testid="reminder-settings-button"
      onClick={()=>{setEditing(true);setDraft(empty);setError("");}}
      style={{position:"fixed",right:12,bottom:12,zIndex:9000,border:"1px solid #e9a23b",
        padding:"8px 12px",borderRadius:8,background:"#fff7e7",cursor:"pointer"}}>⚙ Pengumuman</button>}
    {banner && !editing && <div role="status" aria-live="polite" data-testid="operational-reminder-banner"
      style={{position:"fixed",top:12,left:"50%",transform:"translateX(-50%)",zIndex:9999,
        width:"min(560px,calc(100vw - 24px))",padding:15,background:"#fff7e7",color:"#653611",
        border:"2px solid #f0a539",borderRadius:12,boxShadow:"0 10px 25px #0002",
        pointerEvents:"none",textAlign:"center"}}>
      <strong>🔔 {banner.kind==="ANNOUNCEMENT"?"PENGUMUMAN OPERASIONAL":"PENGINGAT OPERASIONAL"}</strong>
      <div>{banner.message}</div>
    </div>}
    {editing && canConfigure && <div role="dialog" aria-modal="false" aria-label="Pengaturan pengingat operasional"
      style={{position:"fixed",right:16,top:30,zIndex:10001,width:"min(1120px,calc(100vw - 32px))",
        maxHeight:"calc(100vh - 60px)",overflowY:"auto",background:"white",color:"#1f2937",
        border:"1px solid #dbe2ea",borderRadius:14,padding:20,boxShadow:"0 16px 48px #0003"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
        <div><strong style={{fontSize:19}}>Pengumuman & Pengingat</strong>
          <div style={{fontSize:12,color:"#64748b",marginTop:4}}>Atur pesan yang ditampilkan kepada pengguna ERP</div></div>
        <button type="button" onClick={()=>setEditing(false)} aria-label="Tutup pengaturan" style={{border:0,background:"#f1f5f9",borderRadius:8,padding:"8px 12px",cursor:"pointer"}}>✕ Tutup</button>
      </div>
      {notice && <p role="status" style={{padding:9,borderRadius:8,background:"#ecfdf5",color:"#047857"}}>{notice}</p>}
      {error && <p role="alert" style={{padding:9,borderRadius:8,background:"#fef2f2",color:"#991b1b"}}>{String(error)}</p>}
      <section aria-label="Formulir pengingat" style={{minWidth:0,background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:12,padding:16,marginTop:16}}>
        <strong style={{fontSize:16}}>{draft.id?"Edit pengingat":"Pengaturan pesan"}</strong>
        <label style={{display:"block",marginTop:10,fontWeight:600,fontSize:13}}>Isi pesan
          <textarea value={draft.message} maxLength={240} onChange={e=>setDraft({...draft,message:e.target.value})}
            style={{width:"100%",boxSizing:"border-box",minHeight:74,marginTop:5,padding:9,border:"1px solid #cbd5e1",borderRadius:8}} />
        </label>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(190px,1fr))",gap:12,marginTop:12}}>
          <label style={{display:"grid",gap:5,fontSize:13}}>Jenis pesan
            <select value={draft.kind} onChange={e=>setDraft({...draft,kind:e.target.value})} style={{padding:9,borderRadius:8,border:"1px solid #cbd5e1"}}>
              <option value="REMINDER">Pengingat berulang</option><option value="ANNOUNCEMENT">Pengumuman</option></select></label>
          <label style={{display:"grid",gap:5,fontSize:13}}>Jadwal
            <select value={draft.schedule_type} onChange={e=>setDraft({...draft,schedule_type:e.target.value})} style={{padding:9,borderRadius:8,border:"1px solid #cbd5e1"}}>
              <option value="INTERVAL">Berulang</option><option value="DAILY">Harian WIB</option></select></label>
          {draft.schedule_type==="INTERVAL"?
            <label style={{display:"grid",gap:5,fontSize:13}}>Setiap berapa menit?
              <input type="number" min="5" max="1440" value={draft.interval_minutes} onChange={e=>setDraft({...draft,interval_minutes:e.target.value})} style={{padding:9,borderRadius:8,border:"1px solid #cbd5e1"}} /></label>:
            <label style={{display:"grid",gap:5,fontSize:13}}>Jam tampil (WIB)
              <input type="time" value={draft.daily_time_wib||"09:00"} onChange={e=>setDraft({...draft,daily_time_wib:e.target.value})} style={{padding:9,borderRadius:8,border:"1px solid #cbd5e1"}} /></label>}
          <label style={{display:"grid",gap:5,fontSize:13}}>Lama popup (detik)
            <input type="number" min="5" max="30" value={draft.duration_seconds} onChange={e=>setDraft({...draft,duration_seconds:e.target.value})} style={{padding:9,borderRadius:8,border:"1px solid #cbd5e1"}} /></label>
        </div>
        <fieldset style={{marginTop:12,border:"1px solid #dbe2ea",borderRadius:9,padding:10}}>
          <legend style={{fontSize:13,fontWeight:600}}>Ditampilkan kepada</legend>
          <div style={{display:"flex",flexWrap:"wrap",gap:"8px 18px"}}>
            {[["OWNER","Owner"],["ADMIN_INVENTORY","Admin Inventory"],["CHECKER_OPERATOR","Checker / Gudang"]].map(([role,label])=><label key={role} style={{fontSize:13}}>
              <input type="checkbox" checked={draft.target_roles.includes(role)} onChange={e=>setDraft({...draft,target_roles:e.target.checked?[...draft.target_roles,role]:draft.target_roles.filter(x=>x!==role)})}/> {label}
            </label>)}
          </div>
        </fieldset>
        <label style={{display:"block",marginTop:12,fontSize:13}}><input type="checkbox" checked={draft.enabled} onChange={e=>setDraft({...draft,enabled:e.target.checked})}/> Aktifkan pesan</label>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,marginTop:16}}>
          <span style={{fontSize:11,color:"#64748b"}}>Perubahan tersimpan di server ERP · Hanya Owner yang dapat mengatur</span>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",flexWrap:"wrap"}}><button type="button" disabled={saving} onClick={()=>{setDraft({...empty});setError("");setNotice("");}} style={{background:"white",border:"1px solid #cbd5e1",padding:"10px 16px",borderRadius:9,cursor:"pointer"}}>Reset</button><button type="button" disabled={saving} onClick={save} style={{background:"#0f766e",color:"white",padding:"10px 18px",border:0,borderRadius:9,cursor:"pointer"}}>{saving?"Menyimpan...":draft.id?"Simpan Perubahan":"+ Tambah Pengingat"}</button></div>
        </div>
      </section>
      <section aria-label="Daftar pengingat" style={{minWidth:0,marginTop:18,border:"1px solid #e2e8f0",borderRadius:12,padding:16,background:"#fff"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10,marginBottom:12}}>
          <strong style={{fontSize:16}}>Daftar Pengingat ({items.length})</strong>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <input aria-label="Cari pesan pengingat" placeholder="Cari pesan pengingat..." value={search} onChange={e=>setSearch(e.target.value)} style={{padding:"9px 12px",borderRadius:8,border:"1px solid #cbd5e1",minWidth:180}}/>
            <select aria-label="Filter status pengingat" value={filter} onChange={e=>setFilter(e.target.value)} style={{padding:"9px 12px",borderRadius:8,border:"1px solid #cbd5e1"}}>
              <option value="ALL">Semua</option><option value="ACTIVE">Aktif</option><option value="INACTIVE">Nonaktif</option><option value="INTERVAL">Berulang</option><option value="DAILY">Harian</option>
            </select>
          </div>
        </div>
        <div style={{overflowX:"auto",maxHeight:"min(45vh,400px)",overflowY:"auto"}}>
          <table style={{borderCollapse:"collapse",width:"100%",minWidth:730,fontSize:12}}>
            <thead><tr style={{background:"#f1f5f9",textAlign:"left"}}>
              {["No","Pesan","Jenis","Jadwal","Durasi","Penerima","Status","Aksi"].map(h=><th key={h} scope="col" style={{padding:"10px 8px",borderBottom:"1px solid #cbd5e1",whiteSpace:"nowrap"}}>{h}</th>)}
            </tr></thead>
            <tbody>
              {items.filter(x=>(!search||x.message.toLowerCase().includes(search.toLowerCase())) &&
                (filter==="ALL"||(filter==="ACTIVE"&&x.enabled)||(filter==="INACTIVE"&&!x.enabled)||(filter==="INTERVAL"&&x.schedule_type==="INTERVAL")||(filter==="DAILY"&&x.schedule_type==="DAILY")))
                .map((x,i)=><tr key={x.id} style={{background:draft.id===x.id?"#f0fdfa":i%2?"#f8fafc":"#fff"}}>
                  <td style={{padding:9,borderBottom:"1px solid #e2e8f0"}}>{i+1}</td>
                  <td style={{padding:9,borderBottom:"1px solid #e2e8f0",maxWidth:270,overflowWrap:"anywhere",fontWeight:600}}>{x.message}</td>
                  <td style={{padding:9,borderBottom:"1px solid #e2e8f0"}}>{x.kind==="ANNOUNCEMENT"?"Pengumuman":"Pengingat"}</td>
                  <td style={{padding:9,borderBottom:"1px solid #e2e8f0",whiteSpace:"nowrap"}}>{x.schedule_type==="DAILY"?(x.daily_time_wib||"-")+" WIB":"Setiap "+x.interval_minutes+" menit"}</td>
                  <td style={{padding:9,borderBottom:"1px solid #e2e8f0"}}>{x.duration_seconds} dtk</td>
                  <td style={{padding:9,borderBottom:"1px solid #e2e8f0",whiteSpace:"nowrap"}}>{(x.target_roles||[]).map(r=>r==="OWNER"?"O":r==="ADMIN_INVENTORY"?"A":r==="CHECKER_OPERATOR"?"C":r).join(" · ")} <span title="O = Owner, A = Admin Inventory, C = Checker/Gudang" style={{color:"#64748b",cursor:"help"}}>ⓘ</span></td>
                  <td style={{padding:9,borderBottom:"1px solid #e2e8f0"}}><button type="button" disabled={saving} aria-label={(x.enabled?"Nonaktifkan ":"Aktifkan ")+x.message} onClick={()=>toggle(x)} style={{cursor:"pointer",color:x.enabled?"#047857":"#92400e",border:"1px solid #cbd5e1",borderRadius:14,padding:"5px 8px",background:x.enabled?"#ecfdf5":"#fff7ed"}}>{x.enabled?"● Aktif":"○ Nonaktif"}</button></td>
                  <td style={{padding:9,borderBottom:"1px solid #e2e8f0",whiteSpace:"nowrap"}}>
                    <button type="button" disabled={saving} onClick={()=>{setDraft({...x});setNotice("");setError("");}} style={{border:"1px solid #cbd5e1",background:"white",borderRadius:7,padding:"6px 9px",cursor:"pointer",marginRight:5}}>Edit</button>
                    <button type="button" disabled={saving} onClick={()=>remove(x)} aria-label={"Hapus "+x.message} style={{border:"1px solid #fecaca",background:"#fff1f2",color:"#b91c1c",borderRadius:7,padding:"6px 9px",cursor:"pointer"}}>Hapus</button>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {items.length===0 && <p style={{textAlign:"center",color:"#64748b",padding:15}}>Belum ada pengingat. Isi formulir di atas untuk menambahkan.</p>}
          {items.length>0 && !items.some(x=>(!search||x.message.toLowerCase().includes(search.toLowerCase()))&&(filter==="ALL"||(filter==="ACTIVE"&&x.enabled)||(filter==="INACTIVE"&&!x.enabled)||(filter===x.schedule_type))) && <p style={{textAlign:"center",color:"#64748b"}}>Tidak ada pengingat sesuai filter.</p>}
        </div>
      </section>
    </div>}
  </>;
}
